module.exports = __webpack_public_path__ + "static/img/logo-main.9036f47.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-main.svg
// module id = 388
// module chunks = 1